import { Helmet } from "react-helmet";
import { ARButton, IARButton } from "../ARButton/ARButton";
import { DescriptionCard } from "../DescriptionCard";
import { LinkButtonGroup } from "../LinkButtonGroup";
import QRCodeComponent from "../QRCodeComponent";

export interface ITemplate01 {
  themeColor: {
    mainColor: string;
    secondColor: string;
    bgColor: string;
  };
  seo: {
    siteTitle?: string;
    siteDescription: string;
  };
  logo: string;
  logoGrayScale?: string;
  logoRef?: Array<{ logo: string; url?: string }>;
  ARlink: IARButton[];
  qrImg?: string;
  SocialData: {
    whatsapp: string;
    tiktok?: string;
    youtube?: string;
    instagram?: string;
    linkedIn: string;
    email: string;
    line: string;
    facebook: string;
    contactFile: any;
  };
  UserData: {
    userCompany: string;
    userImg: string;
    userName: string;
    userInfo: string;
    userWebsite: string; // link
    nameWebsite: string; // show
    phoneNumber: string;
  };
  DescriptionCard: {
    topic1: string;
    topic2: string;
    info1: string;
    info2: string;
    descriptionHeight: number;
  };
}
export const Template01 = (props: { data: ITemplate01 }) => {
  const { themeColor, logo, logoGrayScale, ARlink, qrImg } = props.data;
  const {
    whatsapp,
    instagram,
    youtube,
    tiktok,
    linkedIn,
    email,
    line,
    facebook,
    contactFile,
  } = props.data.SocialData;
  const {
    userCompany,
    userImg,
    userName,
    userInfo,
    phoneNumber,
    userWebsite,
    nameWebsite,
  } = props.data.UserData;
  const { siteTitle, siteDescription } = props.data.seo;
  const { info1, info2, descriptionHeight, topic2, topic1 } =
    props.data.DescriptionCard;
  // @ts-ignore
  const linearStyle = {
    background: `transparent linear-gradient(180deg, ${themeColor.bgColor}00 0%, ${themeColor.bgColor}4d 40%, ${themeColor.bgColor}b4 55%, ${themeColor.bgColor} 80%) 0% 0% no-repeat padding-box`,
  } as React.CSSProperties;
  const _themeColor = {
    "--secondColor": themeColor.secondColor,
    "--mainColor": themeColor.mainColor,
    "--bgColor": themeColor.bgColor,
  } as React.CSSProperties;
  const _siteTitle = siteTitle ?? userName + " - " + userCompany;
  return (
    <div className="App" style={_themeColor}>
      <Helmet>
        <title>{_siteTitle}</title>
        <meta property="og:title" content={siteTitle}></meta>
        <meta name="description" content={siteDescription} />
        <meta property="og:description" content={siteDescription} />
        <meta property="og:image" content={logo} />
        <link rel="icon" href={logo} />
      </Helmet>
      <div className="App-bg"></div>
      <ARButton data={ARlink}></ARButton>
      <div className="card-container mx-auto">
        <div className="profile-img">
          <div className="com-name" style={{ opacity: 0.2 }}>
            {userCompany}
          </div>
          <img
            alt=""
            src={logoGrayScale || logo}
            style={{
              top: -40,
              left: 200,
              opacity: 0.1,
              filter: "grayscale(100%)",
            }}
            className="com-name-2"
          ></img>
          <img
            alt=""
            src={logoGrayScale || logo}
            style={{
              top: 250,
              left: 100,
              opacity: 0.1,
              filter: "grayscale(100%)",
            }}
            className="com-name-2"
          ></img>
          <img
            alt=""
            src={logo}
            style={{ left: 40, top: 60 }}
            className="logo fade-in"
          ></img>
          <img alt="" src={userImg} className="user-img"></img>
          <div
            style={{
              width: "100%",
              height: "100px",
              flexDirection: "row",
              alignItems: "end",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {props.data.logoRef &&
              props.data.logoRef.map((data) => (
                <img
                  style={{
                    height: "100%",
                    marginRight: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (data.url) {
                      window.open(data.url, "_blank");
                    }
                  }}
                  className="drop-shadow"
                  alt=""
                  src={data.logo}
                ></img>
              ))}
          </div>
          <div className="user-img-bg-blur" style={linearStyle}></div>
          <div className="bg"></div>
          {/* @ts-ignore */}
          <div className="bg-blur" style={linearStyle}></div>
        </div>
        <div className="container">
          <div className="user-name">
            <h1 style={{ fontSize: 35 }}>
              {userName}
              <span></span>
            </h1>
          </div>
          <p className="user-info">{userInfo}</p>
          <p className="company-name">{userCompany}</p>
          <div className="phone-info" style={{ width: "230px" }}>
            {/* <div className="blur" style={{ width: 40, height: 40, backgroundColor: `var(--mainColor)`, left: 1, top: -1 }}></div> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-telephone"
              viewBox="0 0 16 16"
            >
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
            </svg>
            <p>
              <a href={"tel:" + phoneNumber} style={{ color: "white" }}>
                {[
                  phoneNumber.slice(0, 4),
                  "-",
                  phoneNumber.slice(4, 8),
                  "-",
                  phoneNumber.slice(8),
                ].join("")}
              </a>
            </p>
          </div>
          <div className="phone-info" style={{ width: "300px" }}>
            {/* <div className="blur" style={{ width: 40, height: 40, backgroundColor: `var(--mainColor)`, left: 1, top: -1 }}></div> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-browser-safari"
              viewBox="0 0 16 16"
            >
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm.25-14.75v1.5a.25.25 0 0 1-.5 0v-1.5a.25.25 0 0 1 .5 0Zm0 12v1.5a.25.25 0 1 1-.5 0v-1.5a.25.25 0 1 1 .5 0ZM4.5 1.938a.25.25 0 0 1 .342.091l.75 1.3a.25.25 0 0 1-.434.25l-.75-1.3a.25.25 0 0 1 .092-.341Zm6 10.392a.25.25 0 0 1 .341.092l.75 1.299a.25.25 0 1 1-.432.25l-.75-1.3a.25.25 0 0 1 .091-.34ZM2.28 4.408l1.298.75a.25.25 0 0 1-.25.434l-1.299-.75a.25.25 0 0 1 .25-.434Zm10.392 6 1.299.75a.25.25 0 1 1-.25.434l-1.3-.75a.25.25 0 0 1 .25-.434ZM1 8a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 0 .5h-1.5A.25.25 0 0 1 1 8Zm12 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 1 1 0 .5h-1.5A.25.25 0 0 1 13 8ZM2.03 11.159l1.298-.75a.25.25 0 0 1 .25.432l-1.299.75a.25.25 0 0 1-.25-.432Zm10.392-6 1.299-.75a.25.25 0 1 1 .25.433l-1.3.75a.25.25 0 0 1-.25-.434ZM4.5 14.061a.25.25 0 0 1-.092-.341l.75-1.3a.25.25 0 0 1 .434.25l-.75 1.3a.25.25 0 0 1-.342.091Zm6-10.392a.25.25 0 0 1-.091-.342l.75-1.299a.25.25 0 1 1 .432.25l-.75 1.3a.25.25 0 0 1-.341.09ZM6.494 1.415l.13.483a.25.25 0 1 1-.483.13l-.13-.483a.25.25 0 0 1 .483-.13ZM9.86 13.972l.13.483a.25.25 0 1 1-.483.13l-.13-.483a.25.25 0 0 1 .483-.13ZM3.05 3.05a.25.25 0 0 1 .354 0l.353.354a.25.25 0 0 1-.353.353l-.354-.353a.25.25 0 0 1 0-.354Zm9.193 9.193a.25.25 0 0 1 .353 0l.354.353a.25.25 0 1 1-.354.354l-.353-.354a.25.25 0 0 1 0-.353ZM1.545 6.01l.483.13a.25.25 0 1 1-.13.483l-.483-.13a.25.25 0 1 1 .13-.482Zm12.557 3.365.483.13a.25.25 0 1 1-.13.483l-.483-.13a.25.25 0 1 1 .13-.483Zm-12.863.436a.25.25 0 0 1 .176-.306l.483-.13a.25.25 0 1 1 .13.483l-.483.13a.25.25 0 0 1-.306-.177Zm12.557-3.365a.25.25 0 0 1 .176-.306l.483-.13a.25.25 0 1 1 .13.483l-.483.13a.25.25 0 0 1-.306-.177ZM3.045 12.944a.299.299 0 0 1-.029-.376l3.898-5.592a.25.25 0 0 1 .062-.062l5.602-3.884a.278.278 0 0 1 .392.392L9.086 9.024a.25.25 0 0 1-.062.062l-5.592 3.898a.299.299 0 0 1-.382-.034l-.005-.006Zm3.143 1.817a.25.25 0 0 1-.176-.306l.129-.483a.25.25 0 0 1 .483.13l-.13.483a.25.25 0 0 1-.306.176ZM9.553 2.204a.25.25 0 0 1-.177-.306l.13-.483a.25.25 0 1 1 .483.13l-.13.483a.25.25 0 0 1-.306.176Z" />
            </svg>
            <p>
              <a href={userWebsite} style={{ color: "white" }} target="__blank">
                {nameWebsite}
              </a>
            </p>
          </div>
          {/* TODO: auto contactFile  */}
          <LinkButtonGroup
            youtube={youtube}
            instagram={instagram}
            tiktok={tiktok}
            siteTitle={_siteTitle}
            contactFile={contactFile}
            whatsapp={whatsapp}
            phone={phoneNumber}
            linkedIn={linkedIn}
            email={email}
            line={line}
            facebook={facebook}
          />
          <DescriptionCard
            height={descriptionHeight}
            topic1={topic1}
            info1={info1}
            topic2={topic2}
            info2={info2}
          />
          <div style={{ height: 70 }}></div>
          <div style={{ height: 450 }}>
            {/* <img src={qrImg} alt="" width={300} height={300} /> */}
            <QRCodeComponent
              name={props.data.UserData.userName}
              squareColor={'white'}
              dotColor2={'white'}
              dotColor1={'white'}
              backgroundColor="black"
              height={300}
              width={300}
              logo={logo}
            ></QRCodeComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
